import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-c8f51d58"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex items-center text-black text-lg" };
var _hoisted_2 = { class: "form" };
var _hoisted_3 = { style: { "font-size": "15px" } };
var _hoisted_4 = ["checked"];
var _hoisted_5 = { style: { "margin-right": "10px", "margin-left": "1%" } };
var _hoisted_6 = ["checked"];
var _hoisted_7 = { style: { "margin-right": "10px", "margin-left": "1%" } };
var _hoisted_8 = ["checked"];
var _hoisted_9 = { style: { "margin-right": "10px", "margin-left": "1%" } };
var _hoisted_10 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_12 = { for: "medical" };
var _hoisted_13 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_14 = { for: "medical" };
var _hoisted_15 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("option", { value: "" }, null, -1); });
var _hoisted_16 = ["value", "disabled", "selected"];
var _hoisted_17 = {
    value: "nuovoCpp",
    selected: ""
};
var _hoisted_18 = {
    key: 0,
    class: "text-red-500 mb-2 w-full"
};
var _hoisted_19 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_20 = {
    key: 1,
    for: "medical"
};
var _hoisted_21 = {
    key: 3,
    class: "text-red-500 mb-2 w-full"
};
var _hoisted_22 = { for: "confidenzialita" };
var _hoisted_23 = ["value"];
var _hoisted_24 = { class: "flex justify-between" };
import { onMounted, ref } from "vue";
import { patientStore } from "../../store/patient";
import { storeToRefs } from "pinia";
import 'vue-i18n';
import { Modal, Input } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'modal_add',
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var errors = ref([]);
        var mandatoryFields = ['tipo_diagnosi', 'diagnosi_patologia', ['diagnosiDetails', 'careprovider']];
        var loading = ref(false);
        var altroMedico = ref('');
        var medico = ref('');
        var picked = ref('One');
        var alertConfirmMessage = ref(null);
        var modalType = ref("confirm");
        var showConfirm = ref(false);
        var altro = ref(false);
        var row = ref({});
        onMounted(function () {
            row.value.diagnosiDetails = {};
        });
        var resolvePromise;
        function openModal(message, alertModal, newRow) {
            row.value = newRow;
            alertConfirmMessage.value = message;
            alertModal ? (modalType.value = "alert") : (modalType.value = "confirm");
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function handleUserInput(value) {
            if (value) {
                if (!validateFields()) {
                    return false;
                }
            }
            if (!resolvePromise)
                return;
            resolvePromise(value);
            showConfirm.value = false;
        }
        function assignName(value) {
            row.value.tipo_diagnosi = value;
        }
        function forNuovo() {
            if (row.value.diagnosiDetails.careprovider == 'nuovoCpp') {
                row.value.diagnosiDetails.careprovider = '';
                altro.value = true;
            }
            else {
                altro.value = false;
            }
        }
        function validateFields() {
            var hasError = false;
            errors.value = [];
            console.log(mandatoryFields);
            mandatoryFields.forEach(function (field, index) {
                var value = null;
                if (typeof field != 'string') {
                    value = row.value[field[0]][field[1]];
                }
                else {
                    value = row.value[field];
                }
                console.log(value);
                if (!value) {
                    console.log(field);
                    console.log(errors);
                    hasError = true;
                    errors.value.push("Questo campo è obbligatorio!");
                }
                else {
                    errors.value.push("");
                }
            });
            if (hasError) {
                return false;
            }
            return true;
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    size: "2xl",
                    onClose: _cache[10] || (_cache[10] = function ($event) { return (handleUserInput(false)); })
                }, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Aggiungi nuova diagnosi')), 1)
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("Tipologia *")), 1),
                                _createElementVNode("div", null, [
                                    _createElementVNode("input", {
                                        id: "diagnosiRadio",
                                        type: "radio",
                                        onChange: _cache[0] || (_cache[0] = function ($event) { return (assignName('Diagnosi')); }),
                                        checked: _unref(row).tipo_diagnosi == 'Diagnosi'
                                    }, null, 40, _hoisted_4),
                                    _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Diagnosi")), 1),
                                    _createElementVNode("input", {
                                        id: "allergiaRadio",
                                        type: "radio",
                                        onChange: _cache[1] || (_cache[1] = function ($event) { return (assignName('Allergia')); }),
                                        checked: _unref(row).tipo_diagnosi == 'Allergia'
                                    }, null, 40, _hoisted_6),
                                    _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("Allergia")), 1),
                                    _createElementVNode("input", {
                                        id: "intolleranzaRadio",
                                        type: "radio",
                                        onChange: _cache[2] || (_cache[2] = function ($event) { return (assignName('Intolleranza')); }),
                                        checked: _unref(row).tipo_diagnosi == 'Intolleranza'
                                    }, null, 40, _hoisted_8),
                                    _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Intolleranza")), 1)
                                ]),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(errors.value[0]), 1)
                            ]),
                            _hoisted_11,
                            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Diagnosi *")), 1),
                            _createVNode(_unref(Input), {
                                id: "diagnosiType",
                                class: "mb-2",
                                placeholder: _ctx.$t('Inserisci la diagnosi'),
                                modelValue: _unref(row).diagnosi_patologia,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((_unref(row).diagnosi_patologia) = $event); })
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("p", _hoisted_13, _toDisplayString(errors.value[1]), 1),
                            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("Medico *")), 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((_unref(row).diagnosiDetails.careprovider) = $event); }),
                                id: "medical",
                                onChange: _cache[5] || (_cache[5] = function ($event) { return (forNuovo()); }),
                                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            }, [
                                _hoisted_15,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).associated_doctors, function (item, index) {
                                    var _a, _b, _c, _d;
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: index,
                                        value: (_a = item.care_provider) === null || _a === void 0 ? void 0 : _a.fullname,
                                        disabled: ((_b = item.care_provider) === null || _b === void 0 ? void 0 : _b.fullname) === _unref(patient).user.utente_nome ? true : false,
                                        selected: ((_c = item.care_provider) === null || _c === void 0 ? void 0 : _c.fullname) === _unref(patient).user.utente_nome
                                    }, _toDisplayString((_d = item.care_provider) === null || _d === void 0 ? void 0 : _d.fullname), 9, _hoisted_16));
                                }), 128)),
                                _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t("Nuovo Professionista Sanitario")) + "... ", 1)
                            ], 544), [
                                [_vModelSelect, _unref(row).diagnosiDetails.careprovider]
                            ]),
                            (!altro.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(errors.value[2]), 1))
                                : _createCommentVNode("", true),
                            _hoisted_19,
                            (altro.value)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_20, _toDisplayString(_ctx.$t("Altro Medico")), 1))
                                : _createCommentVNode("", true),
                            (altro.value)
                                ? (_openBlock(), _createBlock(_unref(Input), {
                                    key: 2,
                                    class: "mb-2",
                                    modelValue: _unref(row).diagnosiDetails.careprovider,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((_unref(row).diagnosiDetails.careprovider) = $event); })
                                }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                            (altro.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(errors.value[2]), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1),
                            _withDirectives(_createElementVNode("select", {
                                id: "confidenzialita",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((_unref(row).id_livello_confidenzialita) = $event); }),
                                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, function (item, key) {
                                    return (_openBlock(), _createElementBlock("option", {
                                        value: item.id_livello_confidenzialita,
                                        key: key
                                    }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_23));
                                }), 128))
                            ], 512), [
                                [_vModelSelect, _unref(row).id_livello_confidenzialita]
                            ])
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = function ($event) { return (handleUserInput(false)); }),
                                type: "button",
                                class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                            }, _toDisplayString(_ctx.$t("Annulla")), 1),
                            _createElementVNode("button", {
                                id: "submitDiagnosti",
                                onClick: _cache[9] || (_cache[9] = function ($event) { return (handleUserInput(true)); }),
                                type: "button",
                                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, _toDisplayString(_ctx.$t("Salva")), 1)
                        ])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
